import qs from 'qs';

import { apiUrl } from '../envUtil';
import { APIRequest } from '../apiUtil';
import { DataTableQueryType } from 'types/base';

export interface Calendar {
    calendar_id: number;
    name: string;
    url: string;
    calendar_type: number;
    calendar_permission: number;
    description?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string | null;
}

export interface CalendarResponse {
    success: boolean;
    message?: string;
    data: Calendar | Calendar[];
}

export const getCalendars = (params?: DataTableQueryType) => {
    return APIRequest({
        method: 'get',
        url: apiUrl + 'calendars' + (params ? `?${qs.stringify(params)}` : ''),
        useDefaultErrorNotif: true,
    });
};

export const createCalendar = (data: Partial<Calendar>) => {
    return APIRequest({
        method: 'post',
        url: apiUrl + 'calendars',
        data,
        useDefaultErrorNotif: true,
    });
};

export const updateCalendar = (calendarId: number, data: Partial<Calendar>) => {
    return APIRequest({
        method: 'put',
        url: apiUrl + `calendars/${calendarId}`,
        data,
        useDefaultErrorNotif: true,
    });
};

export const deleteCalendar = (calendarId: number) => {
    return APIRequest({
        method: 'delete',
        url: apiUrl + `calendars/${calendarId}`,
        useDefaultErrorNotif: true,
    });
};

export const getCalendarEvents = (params?: DataTableQueryType) => {
    return APIRequest({
        method: 'get',
        url: apiUrl + 'calendar/events' + (params ? `?${qs.stringify(params)}` : ''),
        useDefaultErrorNotif: true,
    });
};

export const syncCalendar = (calendarId: number) => {
    return APIRequest({
        method: 'post',
        url: apiUrl + `calendars/${calendarId}/sync`,
        useDefaultErrorNotif: true,
    });
};

// Sync all integrated calendars
export const syncAllIntegratedCalendars = () => {
    return APIRequest({
        method: 'post',
        url: apiUrl + `calendars/sync-all-integrated-calendars`,
        useDefaultErrorNotif: true,
    });
};
